
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyConicalCross as ObiBuoyConicalCrossElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-conical-cross.js';
 
 
 

 
 export const ObiBuoyConicalCross = createComponent({
   react: React,
   tagName: 'obi-buoy-conical-cross',
   elementClass: ObiBuoyConicalCrossElement,
   events: {
     
   }
  });
 
 